import dayjs from "dayjs";
import MessageDto, { MessageContactTypes } from "../../dto/Message/MessageDto";
import { SupportedLanguages } from "../Settings/TranslationModel";
import i18n from "../../i18n";
import exhaustiveCheck from "../../utils/exhaustiveCheck";

type MessageModel = Omit<MessageDto, "creationDate" | "nextContactDate"> & {
  creationDate: dayjs.Dayjs;
  nextContactDate?: dayjs.Dayjs;
};

export default MessageModel;

export class MessageDataConverter {
  static convertMessage(message: MessageDto): MessageModel {
    return {
      ...message,
      creationDate: dayjs(message.creationDate),
      nextContactDate: message.nextContactDate ? dayjs(message.nextContactDate) : undefined,
    };
  }

  static convertMessages(messages: Array<MessageDto>): Array<MessageModel> {
    return messages.map((x) => this.convertMessage(x));
  }
}

export class MessageUtils {
  static getContactTypeLabel(type: MessageContactTypes, lng: SupportedLanguages) {
    switch (type) {
      case "PHONE":
        return i18n.t("phone", { lng });
      case "EMAIL":
        return "Email";
      case "MESSENGER":
        return i18n.t("messanger", { lng });
      case "OTHER":
        return i18n.t("other", { lng });
      default:
        return exhaustiveCheck(type);
    }
  }
}
